import BaseViewController from "./base-view-controller";
import mapDetailProviderData, {
  sortFields
} from "../utils/provider-detail-builder";

class DetailViewController extends BaseViewController {
  preprocessScreenData() {
    const mappedFields = mapDetailProviderData(
      this.appData.providerDetailFieldsData,
      this.appData.providerDetailData
    );

    // In order to get proper order in the DOM we have to sort fields using sortFields function
    const sortedFields = sortFields(mappedFields);
    this.screen = {
      ...this.screen,
      fields: [...sortedFields]
    };
  }
}

export default DetailViewController;
